// L3 Inspector certification lookup, shared by the Assessment Information
// modal and the Assessment Information card on the object page.
//
// Hierarchy in the general_inspectionStandard DDL collection:
//   primary   = inspection standard
//   secondary = L3 inspector
//   tertiary  = certification (label = cert name; expiryDate = expiry on the item)
//
// Returns null when the chain can't be resolved, otherwise
// { certName, expiryStr, isExpired } — expiryStr/isExpired are null when the
// cert item carries no expiry date.
export function getL3Certification(ddlCollections, inspectionStandard, l3Inspector) {
  if (!inspectionStandard || !l3Inspector) return null;
  const col = (ddlCollections || []).find((c) => {
    if (!c.assignedTo) return false;
    if (Array.isArray(c.assignedTo)) return c.assignedTo.includes('general_inspectionStandard');
    return c.assignedTo === 'general_inspectionStandard';
  });
  if (!col) return null;
  const primaryItem = (col.items || []).find(
    (it) => it.label.trim().toLowerCase() === inspectionStandard.trim().toLowerCase()
  );
  if (!primaryItem) return null;
  const secondaryItem = (primaryItem.children || []).find(
    (it) => it.label.trim().toLowerCase() === l3Inspector.trim().toLowerCase()
  );
  if (!secondaryItem) return null;
  // Tertiary item = the certification itself. Take the first one.
  const tertiaryItem = (secondaryItem.children || [])[0];
  if (!tertiaryItem) return null;

  const certName  = tertiaryItem.label || '';
  const expiryStr = tertiaryItem.expiryDate || null;
  if (!expiryStr) return { certName, expiryStr: null, isExpired: null };

  // Parse with T00:00:00 to avoid UTC-offset day shift (same as DDLDetail)
  const isExpired = new Date(expiryStr + 'T00:00:00') < new Date();
  return { certName, expiryStr, isExpired };
}
